// extracted by mini-css-extract-plugin
export var footer = "_nc-5";
export var fulfillmentInput = "_nc-0";
export var shipDateInput = "_nc-1";
export var shipmentModal = "_nc-2";
export var shipmentModalContent = "_nc-3";
export var tableContainer = "_nc-4";